import React, { PropsWithChildren } from "react";
import cn from "classnames";
import { NavLink } from "react-router-dom";

import { FormattedMessage } from "react-intl";

import routing from "../../../../routing";

import Icon from "../../../../icon";
import {
    MobileMenu,
    StyledMenuItem,
} from "./styles";
import messages from "./messeges";
import { IMenuItemProps, IProps } from "./interfaces";

const MenuItem = ({ display, to, navigate, action, children, active }: PropsWithChildren<IMenuItemProps>) => {
    if (!display) return null;
    return (
        <StyledMenuItem>
            {to && (
                <NavLink to={"/" + to} onClick={navigate} className={cn(active && "Active")}>
                    {children}
                </NavLink>
            )}
            {action && (
                <a
                    onClick={() => {
                        action();
                        navigate();
                    }}
                >
                    {children}
                </a>
            )}
        </StyledMenuItem>
    );
};

const NavMobile = ({
    loggedIn,
    admin,
    mobileMenuOpen,
    navigate,
    logout,
    isLogin,
    isPathChoir,
    isModeration,
    isAccount,
}: IProps) => (
    <MobileMenu show={mobileMenuOpen || undefined}>
        <MenuItem
            to={routing.memory + "/" + routing.choirs}
            display={loggedIn}
            navigate={navigate}
            active={isPathChoir}
        >
            <Icon i="groups" />
            <FormattedMessage {...messages.groups} />
        </MenuItem>

        <MenuItem to={routing.memory + "/" + routing.signup} display={!loggedIn} navigate={navigate}>
            <Icon i="signup" />
            <FormattedMessage {...messages.registration} />
        </MenuItem>

        <MenuItem to={routing.memory + "/" + routing.login} display={!loggedIn} navigate={navigate} active={isLogin}>
            <Icon i="login" />
            <FormattedMessage {...messages.login} />
        </MenuItem>

        <MenuItem
            to={routing.memory + "/" + routing.moderation + "/users"}
            display={admin && loggedIn}
            navigate={navigate}
            active={isModeration}
        >
            <Icon i="admin" />
            <FormattedMessage {...messages.moderation} />
        </MenuItem>

        <MenuItem to={routing.memory + "/" + routing.account} display={loggedIn} navigate={navigate} active={isAccount}>
            <Icon i="account" />
            <FormattedMessage {...messages.account} />
        </MenuItem>

        <MenuItem action={logout} display={loggedIn} navigate={navigate}>
            <Icon i="logout" />
            <FormattedMessage {...messages.logout} />
        </MenuItem>
    </MobileMenu>
);

export default NavMobile;
